/**
 * Stops imitation of current user.
 *
 */
export default class StopImitation {
  constructor(context) {
    this.context = context;
  }

  run() {
    this.context.reset();
    this.context.capacityManager.stop();
    window.location.assign('/admin/imitate');
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/user/stop_imitation.js